// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import Debit from '@deere/cps-it.warranty-model-factory/lib/debit';
import PercentageDebitModal from '../../../shared/components/debit-modal';

function closePercentageDebitModal() {

    this.actions.updatePercentageDebitModalVisibility(false);

}

function handleConfirm() {

    this.actions.updatePercentageDebit(this.debit, this.queryParams.auditNumber);

}

function handleCommentsChange(comments) {

    this.actions.updatePercentageDebitComments(comments);

}

const PercentageDebitModalContainer = props =>
    <PercentageDebitModal
        amountDebit={props.amountDebit}
        busyCounter={props.busyCounter}
        closeModal={props::closePercentageDebitModal}
        debit={props.debit}
        debitType='PERCENTAGE'
        isModalVisible={props.isPercentageDebitModalVisible}
        onCommentsChange={props::handleCommentsChange}
        onConfirmation={props::handleConfirm}
    />;

PercentageDebitModalContainer.displayName = 'PartialDebitModal';
PercentageDebitModalContainer.propTypes = {
    actions: PropTypes.object.isRequired,
    amountDebit: PropTypes.number.isRequired,
    busyCounter: PropTypes.number.isRequired,
    debit: PropTypes.instanceOf(Debit).isRequired,
    isPercentageDebitModalVisible: PropTypes.bool.isRequired,
    queryParams: PropTypes.object.isRequired
};

export default PercentageDebitModalContainer;



// WEBPACK FOOTER //
// ./src/tcsm/percentage-debit/components/percentage-debit-modal/percentage-debit-modal-container.js